import { render, staticRenderFns } from "./SimplySignButton.vue?vue&type=template&id=3b8d0b06&"
import script from "./SimplySignButton.vue?vue&type=script&lang=js&"
export * from "./SimplySignButton.vue?vue&type=script&lang=js&"
import style0 from "./SimplySignButton.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports